import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spinner,
  Text,
  Flex,
} from "@chakra-ui/react";
import React from "react";

export default function WaitingModal() {
  return (
    <Flex
      flex={1}
      bg="blackAlpha.800"
      position="absolute"
      w="100% !important"
      h="100%"
      alignItems='center'
      justifyContent='center'
    >
      <Flex
        w="250px"
        h="60px"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        bg="black"
        borderRadius="5px"

      >
        <Spinner color="white" mb="10px" />
        <Text color="whiteAlpha.600" textAlign="center" fontSize="10px">
          Đang xử lý dữ liệu. Vui lòng đợi trong giây lát
        </Text>
      </Flex>
    </Flex>
  );
}
